import * as Sentry from "@sentry/react";

export class Logger {
  constructor(name, options) {
    const { tags, context } = options || {};
    this.name = name;
    this._tags = tags || {};
    this._context = context || {};
  }

  tags(tags) {
    return new Logger(this.name, {
      tags: { ...this._tags, ...tags },
      context: this._context
    });
  }

  context(context) {
    return new Logger(this.name, {
      tags: this._tags,
      context: { ...this._context, ...context }
    });
  }

  debug(...msg) {
    console.debug(...this._buildConsoleMsg(msg));
  }

  info(...msg) {
    console.log(...this._buildConsoleMsg(msg));
  }

  error(...msg) {
    console.error(...this._buildConsoleMsg(msg));
    this._withSentry(function (ctx) {
      Sentry.captureMessage(msg.map(stringifyNonString).join(", "), ctx);
    });
  }

  _buildConsoleMsg(msgArr) {
    const arr = [`[${this.name}]`, ...msgArr.map(stringifyNonString)];
    // Tags first because context can be big
    Object.entries(this._tags).forEach(([k, v]) =>
      arr.push(`${k}=${stringifyNonString(v)}`)
    );
    Object.entries(this._context).forEach(([k, v]) =>
      arr.push(`${k}=${stringifyNonString(v)}`)
    );
    return arr;
  }

  exception(exc) {
    console.error(exc);
    this._withSentry(function (ctx) {
      Sentry.captureException(exc, ctx);
    });
  }

  _withSentry(cb) {
    try {
      cb({
        tags: { logger: this.name, ...this._tags },
        extra: this._context
      });
    } catch (e) {
      console.error("Error with Sentry:", e);
    }
  }
}

function stringifyNonString(o) {
  return typeof o === "string" ? o : JSON.stringify(o);
}
